import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '../../../src/config/axios.config';
import { API_ENDPOINTS } from '../../../src/shared/api-endpoints';
import { stat } from 'fs';

interface SpecificChatState {
	specificChatResponse: any;
	status: boolean;
	error: string | null;
    lastRequest:null
    newStatus:any
}

const initialState: SpecificChatState = {
	specificChatResponse: {},
	status: false,
	error: null,
    lastRequest:null,
    newStatus:false
    
};

const specificChat = createAsyncThunk<any, any>('specificChat/specificChat', async (payload, thunkAPI) => {
	try {
		const response = await API.post(API_ENDPOINTS.SPECIFIC_CHAT, payload);
		return response.data;
	} catch (error: any) {
		return error.response.data;
	}
});

const specificChatSlice = createSlice({
	name: 'specificChat',
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(specificChat.pending, (state,action:any) => {
				state.error = null;
				state.status = true;
                state.newStatus = true
                state.lastRequest= action.meta.arg

			})
			.addCase(specificChat.fulfilled, (state, action:any) => {
                state.specificChatResponse = action.payload;
                state.lastRequest= action.meta.arg
				state.status = false;
                state.newStatus = false;

			})
			.addCase(specificChat.rejected, (state, action) => {
                state.error = action.error.message || 'Failed to post specific chat data';
				state.status = false;
                state.newStatus = false;
			});
	}
});

export { specificChat };
export const { reset: resetSpecificChat } = specificChatSlice.actions;
export const specificChatReducer = specificChatSlice.reducer;
